module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Guia', {
    attrs: {
      "showGuia": _vm.showGuia,
      "consulta": _vm.consulta
    }
  }), _vm._v(" "), _c('Lote', {
    attrs: {
      "showLote": _vm.showLote,
      "parent": this
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Nova Consulta",
      "onRegister": _vm.onRegister,
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge,
      "loadingTable": _vm.config.loading.table
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-button"
    },
    slot: "table-button"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-copy",
      "type": "success",
      "value": "Gerar Consulta em Lote",
      "title": "Clique aqui para gerar várias consultas ao mesmo tempo."
    },
    on: {
      "click": _vm.onLote
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-656e5b32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/consulta/index.vue
// module id = 1526
// module chunks = 45